import { render, staticRenderFns } from "./serviceProvideManageList.vue?vue&type=template&id=b81ed526&scoped=true"
import script from "./serviceProvideManageList.vue?vue&type=script&lang=js"
export * from "./serviceProvideManageList.vue?vue&type=script&lang=js"
import style0 from "./serviceProvideManageList.vue?vue&type=style&index=0&id=b81ed526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ed526",
  null
  
)

export default component.exports